module.exports = __webpack_public_path__ + "static/img/home_open.416b092.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_open.jpeg
// module id = tdis
// module chunks = 0